export default __webpack_public_path__ + "static/7-b4609aad4293a16a6c25311eb9a7b2bf.png";